import { Rating } from "@/components/Checkin";
import { createContext, useContext } from "react";

type CheckinType = {
    ref: React.MutableRefObject<HTMLElement>;
    isOpen: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    ratings: Rating[];
    setRatings: React.Dispatch<React.SetStateAction<Rating[]>>;
};

type DailyCheckinContextType = {
    morning: CheckinType;
    evening: CheckinType;
};
export const DailyCheckinContext = createContext<DailyCheckinContextType | undefined>(undefined);

export function useDailyCheckinContext() {
    const ctx = useContext(DailyCheckinContext);
    if (!ctx) throw new Error("useDailyCheckinContext must be used within a DailyCheckinProvider");
    return ctx;
}